"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.imgGen.name': 'Image Generation',
    'tools.imgGen.description': 'Generate images from text descriptions',
};
